import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import Fade from "../../components/Fade";
import ListItem from "../../components/ListItem";
import { NewsListType, useGetNewsList } from "../../lib/services";
import { newsStore } from "../../store/news.atom";
import { selectionAtom } from "../../store/selection.atom";

const AllPosts = ({ disableAnimation }: { disableAnimation: boolean }) => {
  const [selection, setSelection] = useRecoilState(selectionAtom);
  const [list, setList] = useRecoilState(newsStore);
  const [loading, setLoading] = useState(false);

  const handleGetNewsList = useGetNewsList();

  useEffect(() => {
    if (selection.category?.id) {
      setLoading(true);
      setSelection((prev) => ({
        ...prev,
      }));
      handleGetNewsList(selection.category.id)
        .then((res) => {
          const data = res.data as NewsListType;

          setList(data.data);
        })
        .finally(() => {
          setLoading(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selection.category?.id]);

  if (loading) {
    return <></>;
  }

  return (
    <div
      className={`${
        (selection.blog === undefined && selection.category !== undefined) ||
        (disableAnimation &&
          selection.category !== undefined &&
          "w-full lg:max-w-80 lg:shrink-0")
      }`}
    >
      <Fade
        isVisible={
          (selection.blog === undefined && selection.category !== undefined) ||
          (disableAnimation && selection.category !== undefined)
        }
      >
        <ul
          className={`custom-scroll flex h-[calc(100dvh-64.8px-64.8px)] w-full !shrink-0 flex-col overflow-y-scroll md:h-[calc(100dvh-103px-69px)] lg:max-w-80`}
        >
          {list.map((content, i) => (
            <ListItem
              key={i}
              onClick={() =>
                setSelection((prev) => ({
                  ...prev,
                  blog: content,
                }))
              }
              className={`${
                selection.blog?.title === content.title
                  ? "!from-[#F3E9FF] !to-white"
                  : ""
              } !font-normal`}
            >
              <div className="text-sm leading-[17.5px] text-rss-muted">
                {new Date(content.published_date).toLocaleDateString()}
              </div>
              <h4 className="line-clamp-3 text-sm leading-[17.5px] text-rss-gray">
                {content.title}
              </h4>
            </ListItem>
          ))}
        </ul>
      </Fade>
    </div>
  );
};

export default AllPosts;
